<!-- driver-application-modal.component.html -->
<div class="flex flex-col h-full w-full">

  <!-- Sticky header -->
  <div class="sticky top-0 z-10 flex items-center justify-between gap-4 px-6 py-4 bg-white border-b border-gray-200 shrink-0">
    <h2 class="text-lg font-bold text-gray-900 truncate">{{ title }}</h2>
    <button mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon svgIcon="circle-x"></mat-icon>
    </button>
  </div>

  <!-- Scrollable form body -->
  <div class="flex-1 overflow-y-auto px-6 py-6">
    <app-driver-application-form
      [matchedLeadsProduct]="data.matchedLeadsProduct"
      [jobPositionId]="data.jobPosition?.id"
      [modal]="this"
    />
  </div>

</div>
